import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SwipeLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"swipe_left"}/>
}
